import { useEffect, useState } from 'react'

import Notifications from 'adminDashboard/common/notifications'

import {
  DashboardInfoStatisticForAdminResponse,
  PlanPeriodDto,
  benefitPlanPeriods,
  getDashboardInfoStatisticForAdmin,
} from 'core'

import { BenefitPlanPeriodDropDown, Card, Row, Skeleton } from 'common/components'
import { useQueryParams, useQueryRequestV2 } from 'common/hooks'

const ActionNeeded = () => {
  const queryParams = useQueryParams()
  const planPeriodIdQueryParam = queryParams.get('planPeriodId')

  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState<PlanPeriodDto | null>(null)

  const { data: statisticInfo, sendQuery: sendGetDashboardStatisticInfo } =
    useQueryRequestV2<DashboardInfoStatisticForAdminResponse>({
      initialState: null,
      queryFn: () => getDashboardInfoStatisticForAdmin(selectedPlanPeriod?.id),
      enable: !!selectedPlanPeriod,
    })
  const { data: planPeriods } = useQueryRequestV2<PlanPeriodDto[]>({
    initialState: null,
    queryFn: () => benefitPlanPeriods(),
  })

  useEffect(() => {
    if (planPeriods && planPeriods.length > 0) {
      const found = planPeriodIdQueryParam
        ? planPeriods.find((x) => x.id === planPeriodIdQueryParam)
        : planPeriods.find((x) => x.active == true)

      if (found) {
        setSelectedPlanPeriod(found)
      }
    }
  }, [planPeriods])

  return (
    <Skeleton loading={!statisticInfo}>
      <Row justify="end" className={'w-100 font-16 text-light-bold mb-16'}>
        {planPeriods && planPeriods.length > 1 && (
          <BenefitPlanPeriodDropDown
            planPeriods={planPeriods}
            defaultValue={planPeriodIdQueryParam}
            onPlanPeriodSelected={(planPeriodId: string) => {
              const found = planPeriods.find((x) => x.id === planPeriodId)
              setSelectedPlanPeriod(found)
              sendGetDashboardStatisticInfo(() => getDashboardInfoStatisticForAdmin(found.id))
            }}
          />
        )}
      </Row>
      <Card title="Action needed">
        {selectedPlanPeriod && (
          <Notifications statisticInfo={statisticInfo} planPeriodId={selectedPlanPeriod.id} planPeriods={planPeriods} />
        )}
      </Card>
    </Skeleton>
  )
}

export default ActionNeeded
